import { Instance, types } from "mobx-state-tree";
import { TranslationContext } from "../translation/TranslationService";

export const BreadcrumbModel = types.model({
  textKey: types.optional(types.string, ''),
  to: types.optional(types.string, ''),
  textContext: types.optional(types.frozen<TranslationContext>(), {}),
  isEllipsis: types.optional(types.boolean, false)
});

export type Breadcrumb = Instance<typeof BreadcrumbModel>;
